module.exports = __webpack_public_path__ + "images/wxwork/ic-wcwf-1-f0062911bd588287071e57a9d5f3980b.png";